import React from 'react';
import { AppSetup } from '../components/Root/AppSetup';
import { Stack } from 'expo-router';

export default function Layout() {
  return (
    <AppSetup>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: '#fff' },
        }}
      />
    </AppSetup>
  );
}
